import { __exportAll } from "../../../../_virtual/_rolldown/runtime.js";
import { by_id_exports } from "./by-id.js";
import { list_exports } from "./list.js";
//#region src/central/v2/users/get/index.ts
var get_exports = /* @__PURE__ */ __exportAll({
	ById: () => by_id_exports,
	List: () => list_exports
});
//#endregion
export { get_exports };

//# sourceMappingURL=index.js.map